"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueNumberCodec = void 0;
const QueueNumberBuilder_1 = require("./QueueNumberBuilder");
const QueueNumberJson_1 = require("./QueueNumberJson");
class QueueNumberCodec {
    fromJson(json) {
        const queueNumberJson = this.formatInput(json);
        return this.convertQueueNumberJsonToQueueNumber(queueNumberJson);
    }
    convertQueueNumberJsonToQueueNumber(queueNumberJson) {
        const builder = new QueueNumberBuilder_1.QueueNumberBuilder()
            .withId(queueNumberJson.id)
            .withNumber(queueNumberJson.number)
            .withCallableAfter(this.formatDateOrNull(queueNumberJson.callableAfter))
            .withCallableUntil(this.formatDateOrNull(queueNumberJson.callableUntil))
            .withTags(queueNumberJson.tags)
            .withLogs(this.formatLogEntry(queueNumberJson.logs));
        if (queueNumberJson.customer !== undefined) {
            builder.withCustomer(this.formatCustomer(queueNumberJson.customer));
        }
        if (queueNumberJson.reservation !== undefined) {
            builder.withReservation(this.formatReservation(queueNumberJson.reservation));
        }
        return builder.build();
    }
    formatDateOrNull(value) {
        if (value === null) {
            return null;
        }
        return new Date(value);
    }
    formatLogEntry(logs) {
        if (logs.length === 0) {
            return [];
        }
        const newLogEntryArray = [];
        logs.forEach((entry) => {
            if (entry.userId) {
                newLogEntryArray.push({
                    type: entry.type,
                    timestamp: new Date(entry.timestamp),
                    userId: entry.userId,
                });
            }
            else {
                newLogEntryArray.push({
                    type: entry.type,
                    timestamp: new Date(entry.timestamp),
                });
            }
        });
        return newLogEntryArray;
    }
    formatInput(input) {
        let result = input;
        try {
            if (typeof result === "string") {
                result = JSON.parse(result);
            }
        }
        catch (error) { }
        if (!(0, QueueNumberJson_1.isQueueNumberJson)(result)) {
            throw new Error("formatInput: Invalid Json or null");
        }
        return result;
    }
    formatCustomer(customer) {
        return customer;
    }
    formatReservation(reservation) {
        const result = reservation;
        if (typeof reservation.start === "string") {
            result.start = new Date(reservation.start);
        }
        if (typeof reservation.end === "string") {
            result.end = new Date(reservation.end);
        }
        return result;
    }
}
exports.QueueNumberCodec = QueueNumberCodec;
//# sourceMappingURL=QueueNumberCodec.js.map